import Axios from "axios";
import {
  SET_NOMINEE_REPORT_LIST,
  UNSET_NOMINEE_REPORT_LIST,
} from "@/store/mutation-types";
import {
  getNomineeReport,
} from "@/store/api";

const state = {
  getNomineeReport: [],
};

const getters = {
  getNomineeReport(state) {
    return state.getNomineeReport;
  },
};

const mutations = {
  [SET_NOMINEE_REPORT_LIST](state, data) {
    state.getNomineeReport = data;
  },
  [UNSET_NOMINEE_REPORT_LIST](state) {
    state.getNomineeReport = [];
  },
};

const actions = {
  getNomineeReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getNomineeReport}`, { params: data })
        .then((response) => {
          commit(SET_NOMINEE_REPORT_LIST, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_NOMINEE_REPORT_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

